module.exports = __webpack_public_path__ + "static/media/ruler-alt.970f85e7.svg";